export const totalcostset = (amount) => {
	return{
		type : 'VALUENEW',
		payload : amount
	};
};

export const paidInFullLanguageUpdater = (text) => {
	return{
		type : 'PAIDINFULLLANGUAGEUPDATE',
		payload : text
	};
};

export const includeInsuranceBalanceNoteUpdate = (note) => {
	return{
		type : 'UPDATEINSURANCENOTE',
		payload : note
	};
};

export const showOtherInputFieldsTrue = () => {
	return{
		type : 'SHOWOTHERTRUE'
	};
};
export const showOtherInputFieldsFalse = () => {
	return{
		type : 'SHOWOTHERFALSE'
	};
};

export const showBillingAddressDropTrue = () => {
	return{
		type : 'SHOWDROPTRUE'
	};
};
export const showBillingAddressDropFalse = () => {
	return{
		type : 'SHOWDROPFALSE'
	};
};

export const showBillingAddressFieldsTrue = () => {
	return{
		type : 'SHOWADDRESSFIELDSTRUE'
	};
};

export const showBillingAddressFieldsFalse = () => {
	return{
		type : 'SHOWADDRESSFIELDSFALSE'
	};
};
export const css_insAdd = () => {
	return{
		type : 'ADDINSURANCEFLAG'
	};
};
export const css_insRemove = () => {
	return{
		type : 'REMOVEINSURANCEFLAG'
	};
};


export const messageDisplayPropertyDisplay = () => {
	return{
		type : 'DISPLAYMESSAGECONTAINER'
	};
};

export const messageDisplayPropertyHide = () => {
	return{
		type : 'HIDEMESSAGECONTAINER'
	};
};



export const message6DisplayPropertyDisplay = () => {
	return{
		type : 'MESSAGE6DISPLAY',
		payload : {display:'block'}
	};
};
export const message6DisplayPropertyHide = () => {
	return{
		type : 'MESSAGE6DISPLAY',
		payload : {display:'none'}
	};
};
export const message8DisplayPropertyDisplay = () => {
	return{
		type : 'DISPLAYMESSAGE8'
	};
};
export const message8DisplayPropertyHide = () => {
	return{
		type : 'HIDEMESSAGE8'
	};
};

export const insuranceStatusIncluded = () => {
	return{
		type : 'STATUSINCLUDED'
	};
};
export const insuranceStatusNotIncluded = () => {
	return{
		type : 'STATUSNOTINCLUDED'
	};
};
export const confirmViewUpdate = (value) => {
	return{
		type : 'CONFIRMVIEWVALUE',
		payload: value
	};
};

export const ccBillingAddressForVerificationUpdate = (value) => {
	return{
		type : 'CCBILLIGNADDRESSFORVERIFICAIONVALUE',
		payload : value
	};
};
export const cssAddress1Update = (value) => {
	return{
		type : 'CSSADDRESS1VALUE',
		payload : value
	};
};
export const cssAddress2Update = (value) => {
	return{
		type : 'CSSADDRESS2VALUE',
		payload : value
	};
};
export const cssCityUpdate = (value) => {
	return{
		type : 'CSSCITYVALUE',
		payload : value
	};
};
export const cssPaymentStateUpdate = (value) => {
	return{
		type : 'CSSPAYMENTSTATEVALUE',
		payload : value
	};
};
export const cssZipUpdate = (value) => {
	return{
		type : 'CSSZIPVALUE',
		payload : value
	};
};
export const ccMonthUpdate = (value) => {
	return{
		type : 'CCMONTHVALUE',
		payload : value
	};
};
export const ccYearUpdate = (value) => {
	return{
		type : 'CCYEARVALUE',
		payload : value
	};
};
export const confirmViewRemainingBalanceUpdate = (value) => {
	return{
		type : 'CONFIRMVIEWREMAININGBALANCECHANGE',
		payload : value
	};
};
export const confirmViewFuturePaymentsUpdate = (value) => {
	return{
		type : 'CONFIRMVIEWFUTUREPAYMENTSCHANGE',
		payload : value
	};
};
export const ccHolderForVerificationNameUpdate = (value) => {
	return{
		type : 'CCHOLDERFORVERIFICATIONNAMEUPDATE',
		payload : value
	};
};
export const scheduledPaymentHasChangedTrue = () => {
	return{
		type : 'SCHEDULEDPAYMENTCHANGED'
	};
};
export const scheduledPaymentHasChangedFalse = () => {
	return{
		type : 'SCHEDULEDPAYMENTNOTCHANGED'
	};
};
export const insuranceStatusPaymentRequired = () => {
	return{
		type : 'PAYMENTREQUIRED'
	};
};

export const insuranceVendorLeisure = () => {
	return{
		type : 'LEISURE'
	};
};
export const insuranceVendorOther = (vendorname) => {
	return{
		type : 'OTHER',
		payload: vendorname
	};
};

export const remainingBalanceNegativeTrue = () => {
	return{
		type : 'NEGATIVE'
	};
};

export const bookingPastDueTrue = () => {
	return{
		type : 'ISPASTDUE'
	};
};

export const balanceDueTrue = () => {
	return{
		type : 'BALANCEEXISTS'
	};
};

export const remainingBalanceSet = (amount) => {
	return{
		type : 'SETREMBAL',
		payload : amount
	};
};

export const paymentDueSet = (valuetext) => {
	return{
		type : 'SETTEXT',
		payload : valuetext
	};
};

export const payRemainingBalanceValue = (amount) => {
	return{
		type : 'PAYREMAINBAL',
		payload : amount
	};
};

export const balancePayRemainingValue = (amount) => {
	return{
		type : 'BALANCEPAYREMAINING',
		payload : amount
	};
};
export const minimumPaymentAmountValue = (amount) => {
	return{
		type : 'UPDATEMINIMUM',
		payload : amount
	};
};

export const bookingDueTodayAnswer = () => {
	return{
		type : 'BOOKINGDUETODAY'
	};
};

export const paymentOptionFull = () => {
	return{
		type : 'FULLAMOUNT'
	};
};

export const paymentOptionOther = () => {
	return{
		type : 'OTHERAMOUNT'
	};
};
export const paymentOptionClear = () => {
	return{
		type : 'CLEARAMOUNT'
	};
};

export const paymentOtherActiveTrue = () => {
	return{
		type : 'PAYMENTOTHERTRUE'
	};
};

export const paymentOtherActiveFalse = () => {
	return{
		type : 'PAYMENTOTHERFALSE'
	};
};


export const paymentAmountUpdater = (amount) => {
	return{
		type : 'NEWPAYMENTAMOUNT',
		payload : amount
	};
};

export const remainingBalanceAsFloatSet = (amount) => {
	return{
		type : 'SETFLOAT',
		payload : amount
	};
};

export const insuranceLinkDisplayPropertyVisible = () => {
	return{
		type : 'SHOWINSURANCELINK'
	};
};

export const paymentOtherUpdate = (amount) => {
	return{
		type : 'PAYMENTOTHERUPDATE',
		payload : amount
	};
};